"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var XeApps = function XeApps() {
  return _react["default"].createElement("svg", {
    width: "127px",
    height: "120px",
    viewBox: "0 0 135.74 124.6",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "apps-title",
    role: "img"
  }, _react["default"].createElement("title", {
    id: "apps-title"
  }, "XE Apps"), _react["default"].createElement("desc", null, "Icon representing XE Apps"), _react["default"].createElement("g", null, _react["default"].createElement("g", null, _react["default"].createElement("rect", {
    x: "27.03",
    y: "3",
    width: "87.6",
    height: "118.52",
    rx: "5.15",
    ry: "5.15",
    fill: "#fff",
    stroke: "#0a146e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "6px"
  }), _react["default"].createElement("path", {
    d: "M37.65,122.54H5.57A3.56,3.56,0,0,1,2,119V51.1a3.56,3.56,0,0,1,3.56-3.56H37.64a3.56,3.56,0,0,1,3.56,3.56V119A3.56,3.56,0,0,1,37.65,122.54Z",
    fill: "#fff",
    stroke: "#0a146e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "4px"
  }), _react["default"].createElement("line", {
    x1: "13.44",
    y1: "49.32",
    x2: "29.78",
    y2: "49.32",
    fill: "none",
    stroke: "#0a146e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "4px"
  }), _react["default"].createElement("rect", {
    x: "128.61",
    y: "81.89",
    width: "7.13",
    height: "10.69",
    rx: "1.95",
    ry: "1.95",
    fill: "#0a146e"
  }), _react["default"].createElement("rect", {
    x: "101.88",
    y: "76.48",
    width: "28.51",
    height: "32.08",
    rx: "4.32",
    ry: "4.32",
    fill: "#fff",
    stroke: "#0a146e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "4px"
  }), _react["default"].createElement("path", {
    d: "M108.38,60.45h15.49a2.36,2.36,0,0,1,2.48,1.76l2.25,16.06H103.66l2.25-16.06A2.36,2.36,0,0,1,108.38,60.45Z",
    fill: "#0a146e"
  }), _react["default"].createElement("path", {
    d: "M123.88,124.6H108.38a2.36,2.36,0,0,1-2.48-1.76l-2.25-16.06h24.95l-2.25,16.06A2.36,2.36,0,0,1,123.88,124.6Z",
    fill: "#0a146e"
  }))));
};

var _default = XeApps;
exports["default"] = _default;